import createRequest from "infrastructure/request/create-request.service";
import { isSuccessResponse } from "presentation/common";
import { service } from "infrastructure";
import AppRouters from "application/globals/app-routers";
import { ModalEvents } from "presentation/common/components/style-guide/modal/ModalEvents";
import { newRequestState } from "./state";
import { isValidVehicleType } from "./validation";
import StorageService from "infrastructure/common/storage";
import { Constant } from "presentation/new-report/common/data";

export async function loadBrandAndBillIssuerAction(dispatch) {
  try {
    const response = await service.loadBrandAndBillIssuerData();
    if (isSuccessResponse(response)) {
      dispatch.newRequest.updateBrandAndBillIssuerAction(
        response.data?.result || []
      );
    }
  } catch (e) {}
}

export async function getManagerByBillIssuerAction(billIssuerName, dispatch) {
  try {
    const response = await service.getManagerByBillIssuer(billIssuerName);
    if (isSuccessResponse(response)) {
      let managers = [];
      if (response.data?.result?.length > 0) {
        managers = response.data?.result[0].manager;
      }

      dispatch.newRequest.updateBillIssuerManagersAction(managers);
    }
  } catch (e) {}
}

export async function loadDispatchBillIssuerAction(billIssuerName, dispatch) {
  try {
    const res = await service.loadBillIssuerDispatch(billIssuerName);
    if (isSuccessResponse(res) && res.data.success) {
      dispatch.newRequest.updateDispatchRegionDataAction(
        res.data?.result || []
      );

      return res.data?.result || [];
    }

    dispatch.common.showErrorMessage({
      message:
        "El emisor de factura no está correctamente configurado. Contáctenos o seleccione otra opción.",
      title: "¡Ajuste Información!",
      svgColor: "#ffb350",
    });

    dispatch.newRequest.updateDispatchRegionDataAction([]);

    return [];
  } catch (e) {
    dispatch.common.showErrorMessage();
  }
}

export function satisfactoryPaymentAction(dispatch) {
  return setTimeout(() => {
    service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
    this.newRequestPatchStateAction(newRequestState);
  });
}

export async function syncCurrentReport(reportId, dispatch) {
  if (!reportId) return;

  try {
    const response = await service.getRequest(reportId);

    if (!isSuccessResponse(response) || !response.data.success) {
      service.eventBus.dispatch("NAVIGATE", {
        path: AppRouters.expiredPaymentError,
      });
      return;
    }

    const data = response.data.result;

    const payload = {
      data: {
        ...data,
        requestId: data.id_solicitud,
        planSelected: {
          type: data.plan,
          price: data.amount,
        },
        paymentType: data.payment_type,
        billInfo: {
          rut: data.rut_billing,
          businessType: data.social_reason,
          economicActivity: data.economic_activity,
          address: data.address,
        },
        licenseNumber: data.preferencia_ppu,
      },
      ui: {
        isReportSync: true,
      },
    };

    this.newRequestPatchStateAction(payload);
    await dispatch.newRequest.onNewRequestAction();
    service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
    return;
  } catch (e) {
    console.log(e);
  }

  dispatch.common.showErrorMessage();
  service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
}

export async function onNewRequestAction({ auth, newRequest }, dispatch) {
  try {
    if (auth.isAuthenticated) {
      const response = await service.payRequest(newRequest.data);
      if (isSuccessResponse(response)) {
        this.newRequestPatchStateAction({
          ...newRequestState,
          ui: { ...newRequestState.ui, isReportSync: true },
        });

        dispatch.common.showSuccessMessage({
          title: "Verificación de datos",
          message:
            "Sus datos han sido verificados, será redireccionado al Banco para efectuar el pago.",
          onClose: () => {
            service.eventBus.dispatch(ModalEvents.CLOSE);
            window.location.assign(response.data.result);
          },
        });

        StorageService.removeItem(Constant.ls_referral_code);
        service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
        return;
      }
    } else {
      const response = await service.saveRequest(newRequest.data);

      if (isSuccessResponse(response)) {
        this.newRequestPatchStateAction(newRequestState);
        dispatch.common.showSendEmailMessage(newRequest.data.email);
        service.eventBus.dispatch("NAVIGATE", { path: AppRouters.home });
        return;
      }
    }
  } catch (e) {}

  dispatch.common.showErrorMessage();

  return false;
}

async function createRequesData(data, dispatch) {
  try {
    const response = await createRequest(data);
    const {
      cotizador,
      factura,
      id_solicitud: requestId,
    } = response?.data?.result;

    const state = { ...data, cotizador, factura, requestId };

    if (!isSuccessResponse(response)) {
      dispatch.common.showErrorMessage();
      return false;
    }

    if (!isValidVehicleType(factura?.tipo_vehiculo)) {
      this.setGeneralData({ ...state, files: [] });
      dispatch.common.showInvalidBillTypeMessage();
      return false;
    }

    this.setGeneralData(state);
    return true;
  } catch (e) {}

  dispatch.common.showErrorMessage();
  return false;
}

export async function updateGeneralDataAction(data, dispatch) {
  try {
    const exist = await service.existRequest(data);

    if (exist.duplicatedOwnerRutOrBill) {
      this.setGeneralData({ ...data, files: [] });
      dispatch.common.showInvalidBillTypeMessage({
        message:
          "Ya existe una solicitud de inscripción para la factura seleccionada.",
      });
      return false;
    }

    if (!exist.rutEmisorMatch) {
      service.eventBus.dispatch("REFRESH_FORM:NOT_MATCH_RUT_EMISOR");
      this.setGeneralData({ ...data, billIssuerSelected: null });
      dispatch.common.showBillIssuerNotMatchMessage();
      return false;
    }

    if (exist.invalidOwner) {
      this.setGeneralData({
        ...data,
        isOwner: null,
        personType: null,
        personInfo: {
          countryCode: "CL",
          rut: "",
          name: "",
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
        },
        ownerBillInfo: {
          businessType: undefined,
          economicActivity: undefined,
          rut: "",
          phone: "",
          countryCode: "CL",
          email: "",
        },
      });

      service.eventBus.dispatch("REFRESH_FORM:INVALID_OWNER");
      dispatch.common.showInvalidOwnerMessage();
      return false;
    }

    if (exist.duplicatedVin) {
      return new Promise((resolve, reject) => {
        dispatch.common.showConfirmMessage({
          title: "¿Está seguro que desea continuar?",
          message:
            "Ya existe una solicitud de inscripción para el vehículo especificado en la factura. Si continúa, se creará una nueva solicitud.",
          onClose: () => {
            resolve(false);
          },
          onCancel: () => {
            resolve(false);
            this.newRequestPatchStateAction(newRequestState);
            service.eventBus.dispatch("NAVIGATE", { path: AppRouters.home });
          },
          onConfirm: async () => {
            this.setPatchGeneralData(data);
            resolve(true);
          },
        });
      });
    }

    this.setPatchGeneralData(data);
    return true;
  } catch (e) {
    dispatch.common.showErrorMessage();
  }
}

export async function updateDispatchDataAction(data, state, dispatch) {
  try {
    this.setPatchGeneralData({ dispatchData: data });

    return await createRequesData.call(
      this,
      { ...state, ...{ ...state.data, dispatchData: data } },
      dispatch
    );
  } catch (e) {
    dispatch.common.showErrorMessage();
  }
}

export function onBackDispatchStepAction(data, dispatch) {
  try {
    this.setPatchGeneralData({ dispatchData: data });
  } catch (error) {
    dispatch.common.showErrorMessage();
  }
}

export async function onExternalErrorAction(
  { error, request },
  state,
  dispatch
) {
  switch (error) {
    case "INCOMPLETE_PAYMENT": {
      return setTimeout(() => {
        service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
        dispatch.common.showErrorMessage({
          message:
            "Realice nuevamente la solicitud. Si el error persiste contáctenos.",
        });
        this.newRequestPatchStateAction(newRequestState);
      }, 100);
    }

    case "payment-denied": {
      return setTimeout(() => {
        service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
        dispatch.common.showInfoMessage({
          message:
            "La solicitud no será procesada porque el pago no fue efectuado.",
          title: "¡Solicitud cancelada!",
        });

        deniedPaymentAction(request);
      }, 100);
    }

    case "payment-canceled": {
      return setTimeout(() => {
        service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
        dispatch.common.showCancelledPaymentMessage();
      }, 100);
    }

    case "EXPIRED_PAYMENT": {
      return setTimeout(() => {
        service.eventBus.dispatch("NAVIGATE", { path: AppRouters.myDocs });
        dispatch.common.showInfoMessage({
          message: "Ha expirado la solicitud, por favor cree una nueva.",
          title: "¡Solicitud Cancelada!",
        });
      }, 100);
    }

    default:
      return null;
  }
}

export const deniedPaymentAction = async (reportId) => {
  try {
    await service.cancelRequest(reportId);
  } catch (e) {}
};
